module.exports = __webpack_public_path__ + "img/userBg.ca35f94e.png";